module.exports = __webpack_public_path__ + "static/media/Indian_Institute_of_Technology_Bombay_Logo.svg.a4a506b3.png";